// extracted by mini-css-extract-plugin
module.exports = {"resetBtn":"_1hHFzBVsZEjP8hGoMJAd8J","icon":"_1YFUjewX51nNsOz-FxCxZw","active":"_1k4njXgLKn3bd4k0G8uJ92"};